import classNames from 'classnames';

import ArrowRightNew from '@/icons/ArrowRightNew';

import Button from '../Button/Button';

import styles from './styles.module.scss';

const SectionTitle = ({
  children,
  onClick,
  buttonText,
  className,
  href,
  titleModify,
  isHtml,
  buttonVariant,
  icon,
}) => {
  const renderTitleVariant = (text) => {
    if (isHtml) {
      return (
        <strong
          className={classNames(['title', titleModify, className])}
          dangerouslySetInnerHTML={{ __html: text }}
        />
      );
    }

    return (
      <strong
        className={classNames(['title', titleModify, className])}
        itemScope
        itemType='https://schema.org/Text'
      >
        {text}
      </strong>
    );
  };

  if (!icon && !buttonText) {
    return renderTitleVariant(children);
  }

  return (
    <div
      className={styles.title__container}
      itemScope
      itemType='https://schema.org/Property'
      data-testid='section-title'
    >
      <div className={styles.title__inner}>
        <strong className={classNames('title', titleModify, className)}>
          {children}
        </strong>
      </div>
      {buttonText && (
        <Button
          href={href}
          Component={href ? 'router' : 'button'}
          onClick={onClick}
          size={'normal'}
          variant={buttonVariant}
          className={styles.button}
        >
          {buttonText} <ArrowRightNew />
        </Button>
      )}
    </div>
  );
};

export default SectionTitle;
